import React, { useState } from "react";
import { useSelector, useDispatch } from "react-redux";
import { Spinner } from "reactstrap";
import Button from "@material-ui/core/Button";
import CurrencyTextField from "@unicef/material-ui-currency-textfield";

import { updateDeliveryFee } from "../../../Store/Modules/Store/Actions";
import { InputGroup, PrimaryBtn } from "../../../Theme";
import { Form, ContainerButtonSubmit } from "../styles";

export default function DeliveryFixed() {
  const dispatch = useDispatch();
  const { deliveryFee, isLoading } = useSelector((state) => state.store);
  const [fee, setFee] = useState(deliveryFee);

  function handleSubmitDeliveryConfig(event) {
    event.preventDefault();
    dispatch({ type: "SET_LOADING" });
    dispatch(updateDeliveryFee(Number(fee)));
  }

  return (
    <Form onSubmit={handleSubmitDeliveryConfig}>
      <CurrencyTextField
        label="Preço"
        size="small"
        name="deliveryPrice"
        style={{ width: "100px" }}
        variant="outlined"
        placeholder="0"
        currencySymbol="R$"
        required
        minimumValue="0"
        outputFormat="number"
        decimalCharacter=","
        digitGroupSeparator="."
        onChange={(ev, value) => setFee(value)}
        value={fee}
      />

      <hr />
      <ContainerButtonSubmit>
        <Button variant="contained" color="primary" type="submit">
          Salvar
        </Button>
        {isLoading && <Spinner type="grow" color="primary" />}
      </ContainerButtonSubmit>
    </Form>
  );
}
